export const UPDATE_SUBSCRIPTION_BASKET = 'UPDATE_SUBSCRIPTION_BASKET';
export const UPDATE_SUBSCRIPTION_BASKET_TEMP_CUSTOMER_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION_BASKET_TEMP_CUSTOMER_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION_BASKET_TEMP_DELIVERY_POINT = 'UPDATE_SUBSCRIPTION_BASKET_TEMP_DELIVERY_POINT';
export const UPDATE_SUBSCRIPTION_BASKET_TEMP_GROUP_DELIVERY_DAY = 'UPDATE_SUBSCRIPTION_BASKET_TEMP_GROUP_DELIVERY_DAY';
export const RESET_SUBSCRIPTION_BASKET_CUSTOMER_SUBSCRIPTION = 'RESET_SUBSCRIPTION_BASKET_CUSTOMER_SUBSCRIPTION';
export const UPDATE_PRODUCT_SELECTORS = 'UPDATE_PRODUCT_SELECTORS';
export const UPDATE_PRODUCT_SELECTORS_V2 = 'UPDATE_PRODUCT_SELECTORS_V2';
export const UPDATE_SUBSCRIPTION_BASKET_CARDID = 'UPDATE_SUBSCRIPTION_BASKET_CARDID';
